export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20golden%20and%20deep%20crimson%20red%20tones%2C%20film%20strip%20elements%20floating%20in%20space%2C%20soft%20dramatic%20lighting%20with%20subtle%20lens%20flare%2C%20movie%20theater%20atmosphere%2C%20elegant%20dark%20gradient%20background%2C%20minimalist%20artistic%20style%2C%20rich%20texture%20details%2C%20no%20text%20or%20letters&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="6080电影网 - 沉浸式观影体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-200 whitespace-nowrap">
                最新电影 · 每日更新
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black tracking-tight leading-tight text-white">
              6080电影网
              <span className="block text-accent-300 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-1">
                高清电影免费在线观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/80 mt-3 font-medium tracking-wide">
              极速秒开 · 无广告 · 不缓冲 · 全平台畅享
            </p>

            <p className="mt-6 text-sm md:text-base leading-relaxed text-white/70 max-w-xl lg:max-w-none">
              6080电影网汇聚海量高清影视资源，涵盖最新院线大片、经典老片、热门剧集与纪录片。采用全球CDN加速节点，
              确保每一帧画面流畅不卡顿，无需等待缓冲，打开即播。每日精选更新，让您第一时间看到想看的电影。
              无论PC端还是移动端，随时随地享受影院级观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-300">10万+</div>
                <div className="text-xs text-white/60 mt-0.5">高清影片资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-300">每日100+</div>
                <div className="text-xs text-white/60 mt-0.5">内容更新上线</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-300">99.9%</div>
                <div className="text-xs text-white/60 mt-0.5">服务在线率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="cursor-pointer inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap transition-all duration-200 hover:bg-primary-600"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="cursor-pointer inline-flex items-center gap-2 px-7 py-3 rounded-full border border-white/30 text-white font-medium text-sm whitespace-nowrap transition-all duration-200 hover:bg-white/10"
              >
                <i className="ri-medal-line text-lg"></i>
                查看榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex justify-center">
            <div className="relative w-64 h-80 sm:w-72 sm:h-96 md:w-80 md:h-[420px] lg:w-[380px] lg:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20composition%2C%20warm%20golden%20spotlight%20illuminating%20a%20floating%20classic%20film%20camera%20and%20vintage%20movie%20reel%2C%20deep%20crimson%20velvet%20curtains%20draped%20on%20sides%2C%20soft%20dramatic%20shadows%2C%20elegant%20theater%20atmosphere%2C%20rich%20contrast%2C%20no%20text%20no%20letters%20no%20people&width=760&height=960&seq=hero-visual-01&orientation=portrait"
                alt="6080电影网 - 高清电影免费在线观看主视觉"
                className="w-full h-full object-cover object-top rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                  <span className="text-xs text-white/80 font-medium">正在热播中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}